import { Loader, Stack } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";
import { fallback, zodValidator } from "@tanstack/zod-adapter";
import { Suspense } from "react";
import { z } from "zod";
import ExerciseFrametimes from "../../../../features/Admin/Frametimes/ExerciseFrametimes";
import Filters from "../../../../features/Admin/Frametimes/Filters";
import SchoolFrametimes from "../../../../features/Admin/Frametimes/SchoolFrametimes";
import SimulatorFrametimes from "../../../../features/Admin/Frametimes/SimulatorFrametimes";
import SimulatorVersionFrametimes from "../../../../features/Admin/Frametimes/SimulatorVersionFrametimes";
import VehicleFrametimes from "../../../../features/Admin/Frametimes/VehicleFrametimes";
import ErrorBoundary from "../../../../components/ErrorBoundary";

export type FrametimeView =
  | "school"
  | "version"
  | "simulator"
  | "exercise"
  | "vehicle";

const framerateSearchSchema = z.object({
  organization_id: fallback(z.number().optional(), undefined),
  filter_school_id: fallback(z.number().optional(), undefined),
  simulator_id: fallback(z.number().optional(), undefined),
  exercise_template_variant_uuid: fallback(z.string().optional(), undefined),
  vehicle_uuid: fallback(z.string().optional(), undefined),
  display_count: fallback(z.enum(["1", "3"]).optional(), undefined),
  major_version: fallback(z.string().optional(), undefined),
  fps_threshold_min: fallback(z.number().optional(), undefined),
  fps_threshold_max: fallback(z.number().optional(), undefined),
  order_by_simulators: fallback(
    z.string().default("SimulatorName"),
    "SimulatorName",
  ),
  order_by_schools: fallback(z.string().default("SchoolName"), "SchoolName"),
  order_by_major_version: fallback(
    z.string().default("MajorVersion"),
    "MajorVersion",
  ),
  order_by_vehicle: fallback(z.string().default("VehicleName"), "VehicleName"),
  order_by_exercise: fallback(
    z.string().default("ExerciseName"),
    "ExerciseName",
  ),
});

export const Route = createFileRoute("/(app)/admin/framerates/")({
  component: RouteComponent,
  validateSearch: zodValidator(framerateSearchSchema),
});

function RouteComponent() {
  return (
    <Stack>
      <Filters />
      <ErrorBoundary message="Failed to load school fps">
        <SchoolFrametimes />
      </ErrorBoundary>

      <ErrorBoundary message="Failed to load simulator fps">
        <SimulatorFrametimes />
      </ErrorBoundary>

      <ErrorBoundary message="Failed to load vehicle fps">
        <VehicleFrametimes />
      </ErrorBoundary>

      <ErrorBoundary message="Failed to load major version fps">
        <SimulatorVersionFrametimes />
      </ErrorBoundary>

      <ErrorBoundary message="Failed to load exercise fps">
        <Suspense fallback={<Loader />}>
          <ExerciseFrametimes />
        </Suspense>
      </ErrorBoundary>
    </Stack>
  );
}
